import React, { Component } from 'react';
import { size, isEmpty } from "lodash";
import { ListLayout } from '../containers/Layout';

import Select from 'react-select'
import { TableRow, TableCell, Button, Grid, TableHead, TableBody, IconButton, Box, Typography } from '@material-ui/core';
import InputText, { InputSelect } from '../../../../commonModules/interface/form-input-inline';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class ListSaleItem extends Component {
    state = { }

    componentDidMount = () => {
        console.log("MOUNTING ListSaleItems ");
    }
    
    // createSaleList = () => {
        //     const { SALES, SHOPS, CLIENTS, PRODUCTS, AGENTS } = this.props
        //     let list = this.filterAll()
            
        //     return  list.map( (sale, index) => {    
        //         if(sale){ // need to check after delete sale/prepa to prvent error
        //             const client = CLIENTS[sale.client_ref]
        //             const shop = SHOPS[sale.shop_id]
        //             const agent = AGENTS && AGENTS[sale.commercial_id]

        //             return sale.products.map( saleItem => {
        //                 let product = PRODUCTS[saleItem.product_id]
        //                 if(this.prodFilter(saleItem.product_id) ){
        //                     return (
        //                         <TableRow key={sale.id + saleItem.product_id} 
        //                             style={{backgroundColor: (index % 2 === 0 && "lightyellow" )}}
        //                         >
        //                             <TableCell>{(new Date(sale.date)).toLocaleString('fr-FR')}</TableCell>
        //                             <TableCell>{product.name} - {product.marque}</TableCell>
        //                             <TableCell>{saleItem.quantity}</TableCell>
        //                             <TableCell>{formatNumbers.format(saleItem.price)}</TableCell>
        //                             <TableCell>{sale.nature}</TableCell>
        //                             <TableCell>
        //                             {shop ? (
        //                                 <a href="#" onClick={
        //                                     () => this.props.handleSingleShop(shop) 
        //                                     }
        //                                 > {shop.name} </a>
        //                                 ) : (
        //                                     <span>{sale.shop_id}</span>
        //                                 )}
        //                             </TableCell>
        //                             <TableCell>
        //                                 <IconButton 
        //                                     color="secondary"
        //                                     onClick={
        //                                         () => this.props.handleSingleSale(sale, shop, client, agent)
        //                                     }
        //                                 >
        //                                     <AddRounded />
        //                                 </IconButton>
        //                             </TableCell>
        //                         </TableRow>
        //                     )
        //                 }
        //             } )
        //         }
        //     })        
    // }  
    createSaleList = (list) => {
        const { SALES, SHOPS, CLIENTS, PRODUCTS, AGENTS, rowsPerPage, currentPageProd } = this.props

        return list.slice(currentPageProd * rowsPerPage, currentPageProd * rowsPerPage + rowsPerPage).map(saleItem => {

            let client = CLIENTS[saleItem.sale_item_client_id]
            let shop = SHOPS[saleItem.sale_item_shop]
            let agent = AGENTS && AGENTS[saleItem.sale_item_commercial_id]
            let product = PRODUCTS[saleItem.product_id]
            let sale = SALES[saleItem.sale_id]
            return (
                <TableRow key={saleItem.id} >
                    <TableCell>{(new Date(saleItem.sale_item_date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{saleItem.sale_item_nature}</TableCell>
                    <TableCell>{product.name} - {product.marque}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>
                    <TableCell>{formatNumbers.format(saleItem.price)}</TableCell>
                    <TableCell>
                        {shop ? (
                            <a 
                                href="#" 
                                onClick={ () => this.props.handleSingleShop(shop) }
                            > 
                                {shop.name}
                            </a>
                        ) : (
                            <span>{saleItem.sale_item_shop}</span>
                        )}
                    </TableCell>
                    <TableCell>
                        <IconButton 
                            color="secondary"
                            onClick={
                                () => this.props.handleSingleSale(sale, shop, client, agent)
                            }
                        >
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })        
    }  
    
    filterAll = () => {
        const { searchProduct } = this.props;

        let newList = this.props.getFilteredList()

        let itemList = []
        newList.forEach(sale => 
            itemList.push(...sale.products)
        )
        if( !isEmpty(searchProduct)){
            itemList = itemList.filter(item => this.props.prodFilter(item.product_id))
        }
        return itemList
    }

    displayList = () => {
        const { SALES } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(SALES)){
            let filteredList = this.filterAll()
            rows = size(filteredList)
            tab = this.createSaleList(filteredList)
        }
        return [tab, rows]
    }

    render() {
        let saleList = this.displayList()

        return (
            <Box>
                <Box p={1}>
                    <Typography variant="h6">Liste des produits vendus</Typography>
                </Box>
                <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Nature</TableCell>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Prix</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Détails</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { saleList[1] !== 0  && 
                            saleList[0]
                        }
                        { saleList[1] === 0  && 
                        <TableCell>
                            <TableCell colSpan={7}>
                                <div className="text-center">
                                    <h5>Pas encore de Ventes</h5> 
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer une nouvelle Vente
                                </div>
                            </TableCell>
                        </TableCell>
                        }
                    </TableBody>
                    { saleList[1] > 20  && 
                        <TableFooterPagination 
                            colSpan={7}
                            // items={saleList[0]} 
                            count={saleList[1]}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPageProd || 0}
                            page={this.props.currentPageProd}
                        />         
                    }                              
                </ListLayout>
            </Box>
        );
    }
}


export default ListSaleItem;